import React from 'react';

import SrCard from 'client/components/SrCard/SrCard';
import SrBox from 'client/components/SrBox';
import SrLink from 'client/components/SrLink/SrLink';

import './UPTips.less';

const UPTips = ({ quickTips }) => {
  const videoTip = quickTips.find((tip) => tip.type === 'video');
  const articleTip = quickTips.filter((tip) => tip.type === 'article');

  return (
    <SrCard width="100%" styleName="UPTips" padding="23px 65px 23px 35px">
      <span styleName="title">Quick videos & articles</span>
      <SrBox styleName="content">
        <SrBox styleName="articleList">
          <ul styleName="linkList">
            {articleTip.map((tip) => (
              <li key={tip.id}>
                <SrLink to={tip.url} target="_blank" color="blue300">
                  {tip.title}
                </SrLink>
              </li>
            ))}
          </ul>
        </SrBox>
        {videoTip && videoTip.url && (
          <SrBox styleName="videoTip">
            <iframe
              styleName="video"
              allowFullScreen
              title="YouTube Video Player"
              src={videoTip.url}
              allow={`accelerometer;
                 autoplay;
                 clipboard-write;
                 encrypted-media;
                 gyroscope;
                 picture-in-picture;
                 web-share`}
            />
          </SrBox>
        )}
      </SrBox>
    </SrCard>
  );
};

export default UPTips;
